import { MessageCircle, Instagram, Facebook, Megaphone, Radio } from 'lucide-react';

export function HeartbeatChannelIcon({ id, provider }: { id: string; provider?: string }) {
    switch (provider || id) {
      case 'whatsapp':
        return (
          <div className="p-1.5 rounded-lg bg-[#25D366]/10 text-[#25D366]">
            <MessageCircle size={15} />
          </div>
        );
      case 'instagram':
        return (
          <div className="p-1.5 rounded-lg bg-pink-500/10 text-pink-400">
            <Instagram size={15} />
          </div>
        );
      case 'facebook_feed':
        return (
          <div className="p-1.5 rounded-lg bg-[#1877F2]/10 text-[#1877F2]">
            <Facebook size={15} />
          </div>
        );
      case 'google_ads':
      case 'meta_lead_ads':
        return (
          <div className="p-1.5 rounded-lg bg-amber-500/10 text-amber-400">
            <Megaphone size={15} />
          </div>
        );
      default:
        return (
          <div className="p-1.5 rounded-lg bg-emerald-500/10 text-emerald-400">
            <Radio size={15} />
          </div>
        );
    }
}
